<div class="searchbar-top gap-2">
  <div class="input-group m-0">
    <input type="text" class="form-control" oninput="this.value = this.value.replace(/^\s+/g, '')"
      [(ngModel)]="enterSearch" placeholder="Search...." aria-label="Search" aria-describedby="search-addon"
      (keyup)="search($event)" />
    <span class="input-group-text border-0" id="search-addon">
      <i class="fas fa-search"></i>
    </span>
    <span type="button" class="input-group-append" (click)="cancelSearch()" *ngIf="searchClose">
      <i class="fas fa-times"></i>
    </span>
  </div>
  <button type="button" class="btn btn-primary common-button m-0" (click)="Addbatch(0)"><i
      class="fas fa-plus pe-2"></i><span>{{CollegeBatchConstant.ADD_BATCH}}</span></button>
</div>
<div class="card-content">
  <div class="row table-touch">
    <div class="col-sm-12">
      <div class="mat-custom-table">
        <div class="table-responsive">
          <table mat-table matSort [dataSource]="dataSource" (matSortChange)="SortChange($event)"
            aria-describedby="list">
            <ng-container matColumnDef="rowNumber">
              <th mat-header-cell *matHeaderCellDef> {{CommonConstant.SR}} </th>
              <td mat-cell *matCellDef="let element"> {{element.rowNumber}} </td>
            </ng-container>
            <ng-container matColumnDef="collegeName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> {{CollegeBatchConstant.CollegeName }} </th>
              <td mat-cell *matCellDef="let element" title="{{element.collegeName}}" class="wrapper"> <span
                  class="paraWrap"> {{element.collegeName}} </span> </td>
            </ng-container>
            <ng-container matColumnDef="batchName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> {{CollegeBatchConstant.BatchName }}</th>
              <td mat-cell *matCellDef="let element"> {{element.batchName}} </td>
            </ng-container>
            <ng-container matColumnDef="batchYear">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> {{CollegeBatchConstant.BatchYear}}
              </th>
              <td mat-cell *matCellDef="let element"> {{element.batchYear}} </td>
            </ng-container>
            <ng-container matColumnDef="TotalStudents">
              <th mat-header-cell *matHeaderCellDef> {{CollegeBatchConstant.TotalStudent}}
              </th>
              <td mat-cell *matCellDef="let element"> {{element.totalStudents}} </td>
            </ng-container>
            <ng-container matColumnDef="isActive">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> {{CommonConstant.STATUS}} </th>
              <td mat-cell *matCellDef="let element">
                <span title="Active / Inactive" *ngIf="element.isActive === true" class="status text-success"
                  (click)="onStatus(element.collegeBatchId,element.batchName,element.isActive)">{{CommonConstant.ACTIVE}}
                </span>
                <span title="Active / Inactive" *ngIf="element.isActive === false" class="status text-danger"
                  (click)="onStatus(element.collegeBatchId,element.batchName,element.isActive)">{{CommonConstant.INACTIVE}}
                </span>
              </td>
            </ng-container>
            <ng-container matColumnDef="Action">
              <th mat-header-cell *matHeaderCellDef>{{CommonConstant.ACTION}} </th>
              <td mat-cell *matCellDef="let element">
                <div class="action-button-group">
                  <a class="detailicon" title="Batch Details" (click)="BatchListDetail(element.collegeBatchId)"><svg
                      xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#fff" class="bi bi-info-lg"
                      viewBox="0 0 16 16">
                      <path
                        d="m9.708 6.075-3.024.379-.108.502.595.108c.387.093.464.232.38.619l-.975 4.577c-.255 1.183.14 1.74 1.067 1.74.72 0 1.554-.332 1.933-.789l.116-.549c-.263.232-.65.325-.905.325-.363 0-.494-.255-.402-.704l1.323-6.208Zm.091-2.755a1.32 1.32 0 1 1-2.64 0 1.32 1.32 0 0 1 2.64 0Z" />
                    </svg></a>
                  <a class="editicon" title="Edit Batch" (click)="Addbatch(element.collegeBatchId)"><svg
                      xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="#003B61" class="bi bi-pencil-fill"
                      viewBox="0 0 16 16">
                      <path
                        d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                    </svg></a>
                  <a class="deleteicon" title="Delete Batch"
                    (click)="Deletepopup(element.collegeBatchId,element.batchName)"><i class="fa fa-trash"></i></a>
                </div>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          <div *ngIf="showData" [ngClass]="dataSource.filteredData.length > 0 ? 'hidden' : 'visible'">
            <h5 class="text-center no-data-available py-4">{{NoRecordFound.NoCollegeBatchFound}}</h5>
          </div>
        </div>
        <mat-paginator #paginator [length]="totalRows" [pageIndex]="currentPage" showFirstLastButtons
          [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" (page)="pageChanged($event)"
          aria-label="Select page">
        </mat-paginator>
      </div>
    </div>
  </div>
</div>